<template>
  <el-select
    v-bind="$attrs"
    class="base-select"
    :class="[`base-select--${variant}`, { 'is-block': block }]"
    :model-value="modelValue"
    :size="normalizedSize"
    @update:model-value="$emit('update:modelValue', $event)"
    @change="$emit('change', $event)"
    @clear="$emit('clear')"
    @visible-change="$emit('visibleChange', $event)"
  >
    <slot />
    <template v-if="$slots.prefix" #prefix>
      <slot name="prefix" />
    </template>
    <template v-if="$slots.header" #header>
      <slot name="header" />
    </template>
    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
    <template v-if="$slots.empty" #empty>
      <slot name="empty" />
    </template>
  </el-select>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean, Array, Object],
    default: ''
  },
  variant: {
    type: String,
    default: 'default'
  },
  size: {
    type: String,
    default: 'default'
  },
  block: {
    type: Boolean,
    default: true
  }
})

defineEmits(['update:modelValue', 'change', 'clear', 'visibleChange'])

const normalizedSize = computed(() => {
  if (props.size === 'large' || props.size === 'small' || props.size === 'default') {
    return props.size
  }
  return 'default'
})
</script>

<style scoped lang="scss">
.base-select.is-block {
  width: 100%;
}

.base-select--filter {
  min-width: 112px;
}

.base-select--filter :deep(.el-select__wrapper),
.base-select--filter :deep(.el-input__wrapper) {
  background: var(--color-surface-muted);
}
</style>
